/** Created by azhou on 2019/3/11.*/
<template>
    <div>
      <public-title>门店资金列表</public-title>
      <div class="load-area">
        <gcon-search @getSearchCon="getSearchCon" />
        <p v-if="StoreLists.total<=0">当前没有数据</p>
        <div v-else>
          <ul class="list-head"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
          <ul class="list-item" v-for="Itemize in StoreLists.lists" :key="Itemize.id">
            <li class="w-50 list-item-col">
              <span class="text-link" @click="goStoreDetail(Itemize.store_id)">{{Itemize.title}}</span>
            </li>
            <li class="w-50 list-item-col flex-column">
              <span class="text-success mr-1">&yen; 
                <label v-if="travel">{{Itemize.money}}</label>
                <label v-else>{{Itemize.money/100 | formatMoney}}</label>
              </span>
              <span class="text-link" v-if="Number(Itemize.money)>0"
                    @click="goForDetail('allowWithdraw',Itemize)">去提现</span>
            </li>
            <li class="w-50 list-item-col flex-column">
              <span class="text-danger mr-1">&yen;
                <label v-if="travel">{{Itemize.freeze_money}}</label> 
                <label v-else>{{Itemize.freeze_money/100 | formatMoney}}</label>
              </span>
              <span class="text-link" v-if="Number(Itemize.freeze_money)>0"
                    @click="goForDetail('Freezing',Itemize)">冻结明细</span>
            </li>
            <li class="w-50 list-item-col flex-column">
              <span class="text-dark mr-1">&yen; 
                <label v-if="travel">{{Itemize.pay}}</label>
                <label v-else>{{Itemize.trade_detail_moneys/100 | formatMoney}}</label>
              </span>
              <span class="text-link" v-if="Itemize.trade_detail_moneys>0 || Number(Itemize.pay) > 0"
                    @click="goForDetail('all',Itemize)">{{travel ? '付' :'收'}}款明细</span>
            </li>
            <li class="w-50 list-item-col flex-column">
              <span class="text-dark mr-1">&yen;
                <label v-if="travel">{{Itemize.withdraw}}</label> 
                <label v-else>{{Itemize.withdraw_money/100 | formatMoney}}</label>
              </span>
              <span class="text-link" v-if="Itemize.withdraw_money>0 || Number(Itemize.withdraw) > 0"
                    @click="goForDetail('WithdrawDone',Itemize)">提现明细</span>
            </li>
            <li class="w-50 list-item-col flex-column" v-if="!travel">
              <span class="text-muted mr-1">&yen; {{Itemize.withdraw_invoice_moneys/100 | formatMoney}}</span>
              <span class="text-link" v-if="Itemize.withdraw_invoice_moneys>0"
                    @click="goForDetail('allowInvoice',Itemize)">去开发票</span>
            </li>
            <li class="w-50 list-item-col" :class="[Itemize.verify === 1 ? 'text-success' : 'text-danger']">
                {{Itemize.verify | formatVar('verifyType')}}
            </li>
            <li class="w-50 list-item-col">
                {{Itemize.province_name}}-{{Itemize.city_name}}-{{Itemize.district_name}}
            </li>
            <li class="w-50 list-item-col-end">
              <span class="text-link" @click="goForDetail('all',Itemize)">门店资金管理</span>
            </li>
          </ul>
          <el-pagination background layout="prev, pager, next" class="mt-4"
            :total="StoreLists.total" :current-page="Number(queryCon.page)"
            @current-change="v => this.$router.push({name:this.$route.name,query:{page:v}})"/>
        </div>
      </div>
    </div>
</template>

<script>
  import { mapGetters, mapState,mapActions } from 'vuex'
  import GconSearch from '../GconSearch'

  export default {
    name: 'GroupMoneyLists',
    components: { GconSearch },
    computed: {
      ...mapState(['StoreLists']),
      ...mapGetters(['storeInfo']),
      queryCon() { return this.$route.query },
      travel () { return this.storeInfo.type == 2 },
      titleArr () {
        if (this.travel) return ['门店名称','门店余额','冻结金额','累计付款','累计提现','门店认证','所在地','操作'];
        else return ['门店名称','门店余额','冻结金额','累计收款','累计提现','可开发票','门店认证','所在地','操作'];
      }
    },
    watch:{
      queryCon() { 
        if (this.travel) this.TraGroupGetStoreLists({ url: this.url, data: {...this.info} })
        else this.groupGetStoreLists({ page:this.queryCon.page, type:9, ...this.info })
      },
    },
    data() {
      return {
        info: {},
        url: '/pc/Travel/getStoreRefund'
      }
    },
    created() {
      if (this.queryCon.hasOwnProperty('page')) {
        if (this.travel) this.TraGroupGetStoreLists({ url: this.url})
        else this.groupGetStoreLists({ page:this.queryCon.page, type:9 })
      } else {
        if (this.travel) this.TraGroupGetStoreLists({ url: this.url, data: {page:1} })
        else this.groupGetStoreLists({ page:1, type:9 })
      }
    },
    methods:{
      ...mapActions(['groupGetStoreLists','TraGroupGetStoreLists']),
      //资金详细项点击跳转
      goForDetail(flag,Itemize) {
        this.$router.push({name:this.$route.name,query:{store:Itemize.store_id,tab:flag,GST:Itemize.title}})
      },
      //查看门店详情页
      goStoreDetail(id) {
        let routeUrl = this.$router.resolve({name:'StoreDetail',query:{type:this.storeInfo.type,id}});
        window.open(routeUrl.href, '_blank');
      },
      getSearchCon (info) {
        this.info=info;
        if (this.travel) this.TraGroupGetStoreLists({ url: this.url, data: {page:1, ...info} })
        else this.groupGetStoreLists({ page:1, type:9, ...info })
      }
    }
  }
</script>
